module.exports = __webpack_public_path__ + "static/mail-lanterns-7c0a54992dfdfd40af42e4f39e8a45c8.jpg";